export const SUPPORTED_CURRENCIES = [
  "JPY",
  "USD",
  "EUR",
  "GBP",
  "KRW",
  "CNY",
  "TWD",
  "THB",
  "HKD",
  "MOP",
  "SGD",
  "VND",
  "MYR",
  "IDR",
  "PHP",
  "INR",
  "AED",
  "SAR",
  "TRY",
  "AUD",
  "NZD",
  "CAD",
  "CHF",
  "SEK",
  "NOK",
  "DKK",
  "PLN",
  "CZK",
  "MXN",
  "BRL",
];

export const CURRENCY_NAMES = Object.freeze({
  JPY: "日本円",
  USD: "米ドル",
  EUR: "ユーロ",
  GBP: "英ポンド",
  KRW: "韓国ウォン",
  CNY: "中国人民元",
  TWD: "台湾ドル",
  THB: "タイバーツ",
  HKD: "香港ドル",
  MOP: "マカオ・パタカ",
  SGD: "シンガポールドル",
  VND: "ベトナムドン",
  MYR: "マレーシアリンギット",
  IDR: "インドネシアルピア",
  PHP: "フィリピンペソ",
  INR: "インドルピー",
  AED: "UAEディルハム",
  SAR: "サウジアラビアリヤル",
  TRY: "トルコリラ",
  AUD: "オーストラリアドル",
  NZD: "ニュージーランドドル",
  CAD: "カナダドル",
  CHF: "スイスフラン",
  SEK: "スウェーデンクローナ",
  NOK: "ノルウェークローネ",
  DKK: "デンマーククローネ",
  PLN: "ポーランドズウォティ",
  CZK: "チェココルナ",
  MXN: "メキシコペソ",
  BRL: "ブラジルレアル",
});

export const normalizeCurrency = (code) => {
  const normalized = String(code || "JPY").trim().toUpperCase();
  return /^[A-Z]{3}$/.test(normalized) ? normalized : "JPY";
};

export const formatCurrencyOption = (code) => {
  const normalized = normalizeCurrency(code);
  const name = CURRENCY_NAMES[normalized];
  return name ? `${normalized}（${name}）` : normalized;
};

export const buildCurrencyOptions = (selectedCurrency) => {
  const options = [...SUPPORTED_CURRENCIES];
  const selected = normalizeCurrency(selectedCurrency);
  if (!options.includes(selected)) options.push(selected);
  return options;
};

export const buildExchangeRateMap = (rates = []) => {
  const map = { JPY: 1 };
  (Array.isArray(rates) ? rates : []).forEach((rate) => {
    const currency = normalizeCurrency(rate.CURRENCY || rate.currency);
    const rateToJpy = Number(rate.RATE_TO_JPY ?? rate.rateToJpy);
    if (currency && Number.isFinite(rateToJpy) && rateToJpy > 0) {
      map[currency] = rateToJpy;
    }
  });
  return map;
};

export const getRateToJpy = (currency, exchangeRateMap = {}) => {
  const normalized = normalizeCurrency(currency);
  if (normalized === "JPY") return 1;
  const rate = Number(exchangeRateMap[normalized]);
  return Number.isFinite(rate) && rate > 0 ? rate : null;
};

export const toJpy = (amount, currency, exchangeRateMap = {}) => {
  const numericAmount = Number(amount);
  if (!Number.isFinite(numericAmount)) {
    return { amount: 0, missingRate: false };
  }
  const rate = getRateToJpy(currency, exchangeRateMap);
  if (!rate) {
    return { amount: 0, missingRate: true };
  }
  return {
    amount: Math.round(numericAmount * rate),
    missingRate: false,
  };
};

export const formatCurrencyAmount = (amount, currency = "JPY") => {
  const normalized = normalizeCurrency(currency);
  const fractionDigits = normalized === "JPY" ? 0 : 2;
  return `${normalized} ${Number(amount || 0).toLocaleString("ja-JP", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })}`;
};

export const formatJpy = (amount) =>
  `JPY ${Math.round(Number(amount) || 0).toLocaleString("ja-JP")}`;

export const formatExpenseAmount = (
  amount,
  currency,
  exchangeRateMap = {},
) => {
  const normalized = normalizeCurrency(currency);
  const converted = toJpy(amount, normalized, exchangeRateMap);
  if (normalized === "JPY") return formatJpy(amount);
  if (converted.missingRate) {
    return `${formatCurrencyAmount(amount, normalized)} / JPY -`;
  }
  return `${formatCurrencyAmount(amount, normalized)} / ${formatJpy(
    converted.amount,
  )}`;
};
